import Cookies from 'js-cookie'
const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'en',
    menuId: { href: '', menuId: -2 },
    theme: JSON.parse(localStorage.getItem('theme')) || {
      mainColor: '#2053CD',
      btnColor: '#2053CD',
      navbarColor: '#1b1f24',
      menuColor: '#304156',
      name: 'theme-1'
    }
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_MENUID: (state, menuId) => {
      state.menuId = menuId
    },
    SET_THEME: (state, theme) => {
      state.theme = theme
      localStorage.setItem('theme', JSON.stringify(theme))
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setMenuId({ commit }, menuId) {
      commit('SET_MENUID', menuId)
    },
    setTheme({ commit }, theme) {
      commit('SET_THEME', theme)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js